// Parse the trip-narrative markdown into per-day prose. The MD is split on
// `## Day N — ...` headings; each section runs until the next `## ` heading
// or the end of the file. The trip-level preamble and the trailing reference
// sections (Photo Spot Priority, Quick Facts, Booking Checklist) are not
// associated with a day.

export interface DayNarrative {
  day: number;
  /** Original heading text, e.g. `Wed, Apr 29: Berlin → Hamburg → Blåvand`. */
  heading: string;
  /** Markdown body for that day, with the heading line stripped. */
  body: string;
}

export function parseDayNarratives(source: string): Record<number, DayNarrative> {
  const out: Record<number, DayNarrative> = {};
  // Split keeps the leading "Day " gone; sections[0] is everything before the first "## Day ".
  const sections = source.split(/^## Day\s+/m);
  for (let i = 1; i < sections.length; i++) {
    const section = sections[i];
    const headerMatch = section.match(/^(\d+)\s*—\s*(.+?)\n/);
    if (!headerMatch) continue;
    const day = parseInt(headerMatch[1], 10);
    const heading = headerMatch[2].trim();
    let body = section.slice(headerMatch[0].length);
    // Stop at the next top-level section (e.g. "## Photo Spot Priority").
    const nextHeader = body.search(/\n## /);
    if (nextHeader >= 0) body = body.slice(0, nextHeader);
    body = body.replace(/\n---\s*$/, '').trim();
    out[day] = { day, heading, body };
  }
  return out;
}
